"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornmentWrapper = exports.StyledTextFieldAdornmentWrapper = exports.StyledTextArea = exports.StyledTextField = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _commonElements = require("../utils/commonElements");

var _helpers = require("../utils/helpers");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n      padding: 0 ", ";\n      min-width: auto;\n      background: transparent;\n      border: none;\n      border-bottom: 1px solid ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: ", " 0 0 0;\n  padding: 0 ", ";\n  background: ", ";\n  color: ", ";\n  fill: currentColor;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  min-width: ", ";\n\n  input + & {\n    border-right: 1px solid ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n      width: 100%;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border-right: none;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      border-left: none;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      border-right: none;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      border-left: none;\n      border-top-left-radius: 0;\n      border-bottom-left-radius: 0;\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTextField = (0, _styledComponents.default)(_commonElements.CalciteInput)(_templateObject(), function (props) {
  return props.hasAdornmentLeft && (0, _styledComponents.css)(_templateObject2());
}, function (props) {
  return props.hasAdornmentRight && (0, _styledComponents.css)(_templateObject3());
});
exports.StyledTextField = StyledTextField;
var StyledTextArea = (0, _styledComponents.default)(_commonElements.CalciteTextarea)(_templateObject4(), function (props) {
  return props.hasAdornmentLeft && (0, _styledComponents.css)(_templateObject5());
}, function (props) {
  return props.hasAdornmentRight && (0, _styledComponents.css)(_templateObject6());
});
exports.StyledTextArea = StyledTextArea;

var StyledTextFieldAdornmentWrapper = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.fullWidth && (0, _styledComponents.css)(_templateObject8());
});

exports.StyledTextFieldAdornmentWrapper = StyledTextFieldAdornmentWrapper;

var StyledAdornmentWrapper = _styledComponents.default.div(_templateObject9(), function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 6, '/');
}, function (props) {
  return (0, _helpers.unitCalc)(props.theme.baseline, 4, '/');
}, function (props) {
  return props.theme.palette.lightestGray;
}, function (props) {
  return props.theme.palette.darkerGray;
}, function (props) {
  return props.theme.palette.lightGray;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.baseline;
}, function (props) {
  return props.theme.palette.lightGray;
}, function (props) {
  return props.minimal && (0, _styledComponents.css)(_templateObject10(), function (props) {
    return (0, _helpers.unitCalc)(props.theme.baseline, 6, '/');
  }, function (props) {
    return props.theme.palette.lighterGray;
  });
}, function (props) {
  return props.adornmentDirection === 'left' && (0, _styledComponents.css)(_templateObject11());
}, function (props) {
  return props.adornmentDirection === 'right' && (0, _styledComponents.css)(_templateObject12());
});

exports.StyledAdornmentWrapper = StyledAdornmentWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/TextField/TextField-styled.js
// module id = 1579
// module chunks = 0